import script from "./studentReviews.vue?vue&type=script&setup=true&lang=js"
export * from "./studentReviews.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__